// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/risk.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/risk.proto.
 */
export const file_inventory_v1_risk: GenFile = /*@__PURE__*/
  fileDesc("ChdpbnZlbnRvcnkvdjEvcmlzay5wcm90bxIMaW52ZW50b3J5LnYxIjYKFVJpc2tTZXZlcml0eUF4aXNTY29yZRINCgVzY29yZRgBIAEoBRIOCgZyZWFzb24YAiABKAki0gQKEVJpc2tTZXZlcml0eVNjb3JlEjwKD2NvbmZpZGVudGlhbGl0eRgBIAEoCzIjLmludmVudG9yeS52MS5SaXNrU2V2ZXJpdHlBeGlzU2NvcmUSNgoJaW50ZWdyaXR5GAIgASgLMiMuaW52ZW50b3J5LnYxLlJpc2tTZXZlcml0eUF4aXNTY29yZRI5CgxhdmFpbGFiaWxpdHkYAyABKAsyIy5pbnZlbnRvcnkudjEuUmlza1NldmVyaXR5QXhpc1Njb3JlEjcKCnJlZ3VsYXRvcnkYBCABKAsyIy5pbnZlbnRvcnkudjEuUmlza1NldmVyaXR5QXhpc1Njb3JlEjsKDnRyaWdnZXJhYmlsaXR5GAUgASgLMiMuaW52ZW50b3J5LnYxLlJpc2tTZXZlcml0eUF4aXNTY29yZRIyCgVyZWFjaBgGIAEoCzIjLmludmVudG9yeS52MS5SaXNrU2V2ZXJpdHlBeGlzU2NvcmUSDQoFc2NvcmUYByABKAESJQoEdGllchgIIAEoDjIXLmludmVudG9yeS52MS5SaXNrTGV2ZWwSFQoNdW5jZXJ0YWludGllcxgJIAMoCRIbChNtYW51YWxseV9vdmVycmlkZGVuGAogASgIEjYKDW92ZXJyaWRkZW5fYXQYCyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESLgoKY3JlYXRlZF9hdBgMIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCEAoOX292ZXJyaWRkZW5fYXQqgAEKCVJpc2tMZXZlbBIaChZSSVNLX0xFVkVMX1VOU1BFQ0lGSUVEEAASEgoOUklTS19MRVZFTF9MT1cQARIVChFSSVNLX0xFVkVMX01FRElVTRACEhMKD1JJU0tfTEVWRUxfSElHSBADEhcKE1JJU0tfTEVWRUxfQ1JJVElDQUwQBCpkCghSaXNrVHlwZRIZChVSSVNLX1RZUEVfVU5TUEVDSUZJRUQQABIfChtSSVNLX1RZUEVfSU5TRUNVUkVfREVGQVVMVFMQARIcChhSSVNLX1RZUEVfRFJJRlRfT0ZfU0NPUEUQAkKxAQoQY29tLmludmVudG9yeS52MUIJUmlza1Byb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message inventory.v1.RiskSeverityAxisScore
 */
export type RiskSeverityAxisScore = Message<"inventory.v1.RiskSeverityAxisScore"> & {
  /**
   * @generated from field: int32 score = 1;
   */
  score: number;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message inventory.v1.RiskSeverityAxisScore.
 * Use `create(RiskSeverityAxisScoreSchema)` to create a new message.
 */
export const RiskSeverityAxisScoreSchema: GenMessage<RiskSeverityAxisScore> = /*@__PURE__*/
  messageDesc(file_inventory_v1_risk, 0);

/**
 * Support-only. Never add to customer-facing responses.
 *
 * @generated from message inventory.v1.RiskSeverityScore
 */
export type RiskSeverityScore = Message<"inventory.v1.RiskSeverityScore"> & {
  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore confidentiality = 1;
   */
  confidentiality?: RiskSeverityAxisScore;

  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore integrity = 2;
   */
  integrity?: RiskSeverityAxisScore;

  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore availability = 3;
   */
  availability?: RiskSeverityAxisScore;

  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore regulatory = 4;
   */
  regulatory?: RiskSeverityAxisScore;

  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore triggerability = 5;
   */
  triggerability?: RiskSeverityAxisScore;

  /**
   * @generated from field: inventory.v1.RiskSeverityAxisScore reach = 6;
   */
  reach?: RiskSeverityAxisScore;

  /**
   * @generated from field: double score = 7;
   */
  score: number;

  /**
   * @generated from field: inventory.v1.RiskLevel tier = 8;
   */
  tier: RiskLevel;

  /**
   * @generated from field: repeated string uncertainties = 9;
   */
  uncertainties: string[];

  /**
   * @generated from field: bool manually_overridden = 10;
   */
  manuallyOverridden: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp overridden_at = 11;
   */
  overriddenAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.RiskSeverityScore.
 * Use `create(RiskSeverityScoreSchema)` to create a new message.
 */
export const RiskSeverityScoreSchema: GenMessage<RiskSeverityScore> = /*@__PURE__*/
  messageDesc(file_inventory_v1_risk, 1);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from enum inventory.v1.RiskLevel
 */
export enum RiskLevel {
  /**
   * @generated from enum value: RISK_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RISK_LEVEL_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: RISK_LEVEL_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: RISK_LEVEL_HIGH = 3;
   */
  HIGH = 3,

  /**
   * @generated from enum value: RISK_LEVEL_CRITICAL = 4;
   */
  CRITICAL = 4,
}

/**
 * Describes the enum inventory.v1.RiskLevel.
 */
export const RiskLevelSchema: GenEnum<RiskLevel> = /*@__PURE__*/
  enumDesc(file_inventory_v1_risk, 0);

/**
 * @generated from enum inventory.v1.RiskType
 */
export enum RiskType {
  /**
   * @generated from enum value: RISK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RISK_TYPE_INSECURE_DEFAULTS = 1;
   */
  INSECURE_DEFAULTS = 1,

  /**
   * @generated from enum value: RISK_TYPE_DRIFT_OF_SCOPE = 2;
   */
  DRIFT_OF_SCOPE = 2,
}

/**
 * Describes the enum inventory.v1.RiskType.
 */
export const RiskTypeSchema: GenEnum<RiskType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_risk, 1);

